import { UserApi } from '../../../common/constants/user-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { getAppFlow } from '../utils/user-profile.util';

export async function userSignoutApi() {
  const url = new URL(UserApi.signout);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Flow: getAppFlow(),
      },
    })
  );
}
